import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="memories-intro"]' },
  { target: '[data-tour="memories-actions"]' },
  { target: '[data-tour="memories-filters"]' },
  { target: '[data-tour="memories-feed"]' }
];

export const FAMILY_MEMORIES_TOUR_STEPS: TourStep[] = buildTourSteps('familyMemories', STEP_DEFS);

export const FAMILY_MEMORIES_TOUR_STORAGE_KEY = 'wetree-family-memories-tour-completed';

export function resolveFamilyMemoriesTourSteps(steps: TourStep[], hasMemories: boolean): TourStep[] {
  if (hasMemories) {
    return steps;
  }
  return steps.filter((step) => step.target !== '[data-tour="memories-feed"]');
}
